import { useParams } from 'react-router-dom';
import { Alert, QueryState } from '@integra/ui';
import { useSharedReport } from '../api/hooks.js';
import { ReportView } from './ReportView.js';

/**
 * The public client portal (§20.5). A read-only, white-labelled report a client
 * opens with a share link and no login — rendered outside the app shell. The
 * snapshot is immutable, so the client sees exactly what was frozen at
 * generation, provenance intact (§2.7).
 */
export function PublicReportPage() {
  const { token = '' } = useParams<{ token: string }>();
  const report = useSharedReport(token);

  return (
    <div className="min-h-screen bg-surface-muted py-10">
      <div className="mx-auto max-w-3xl rounded-xl border border-edge bg-surface p-6 shadow-card sm:p-10">
        <QueryState loading={report.isLoading} error={null} what="the report">
          {report.error !== null ? (
            <Alert tone="error" title="This report link is not valid">
              The link may have been unshared or has expired. Ask your contact for a fresh link.
            </Alert>
          ) : report.data !== undefined ? (
            <ReportView title={report.data.data.title} snapshot={report.data.data.snapshot} />
          ) : null}
        </QueryState>
      </div>
    </div>
  );
}
